import React, { useState } from "react";
import SlotCounter from "react-slot-counter";
import { toast } from "react-toastify";

const CounterApp = ({ tokenValue }) => {
  const [targetNumber, setTargetNumber] = useState("PME");
  const [isDisabled, setIsDisabled] = useState(false);
  const handleStart = () => {
    setTargetNumber(tokenValue);
    setIsDisabled(true);
    setTimeout(() => {
      toast.success(`Spin ended! You will get ${tokenValue} PME!`);
    }, 12000);
  };

  return (
    <div className="counter-box">
      <SlotCounter
        value={targetNumber}
        // startValue={startValue} // Starting from 0
        duration={12} // Animation duration in seconds
        speed={2} // Control the speed of the counter when running
        delay={0.1} // Delay between each column animation
        dummyCharacterCount={6} // Optional: Number of dummy characters before reaching the target
        autoAnimationStart={false} // Automatically start the animation when component is mounted
        charClassName="counter-char" // Class for individual characters
        numberClassName="counter-number" // Class for numbers
      />

      <button onClick={handleStart} className="spin-btn" disabled={isDisabled}>
        Spin
      </button>
    </div>
  );
};

export default CounterApp;
